import { render } from "./App.vue?vue&type=template&id=5cd6e6fb"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5cd6e6fb&lang=css"
script.render = render

export default script